import { useCallback } from "react";
import { apiService } from "../service/apiClient.js";
import { apiUrl } from "../service/apiUrl.js";

export const useUserManagement = () => {
  const createUser = useCallback(async (payload) => {
    return apiService.post(apiUrl.users(), payload);
  }, []);

  const fetchUsers = useCallback(async () => {
    const res = await apiService.get(apiUrl.users());
    return res.data || [];
  }, []);

  const deleteUserById = useCallback(async (userId) => {
    return apiService.delete(apiUrl.userById(userId));
  }, []);

  const updateUserById = useCallback(
    async (userId, payload) => {
      const toolAccess = payload.toolAccess
        ? Array.isArray(payload.toolAccess)
          ? payload.toolAccess
          : [payload.toolAccess]
        : [];

      return apiService.post(apiUrl.updateUser(), {
        role: payload.role,
        toolAccess,
        userID: userId,
      });
    },
    []
  );

  return {
    createUser,
    fetchUsers,
    deleteUserById,
    updateUserById,
  };
};

export default useUserManagement;
